"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var graphql_ld_1 = require("graphql-ld");

var rdf_store_stream_1 = require("rdf-store-stream");

var ActorRdfMetadataExtract_1 = require("./ActorRdfMetadataExtract");

var GraphQlQueryEngine_1 = require("./GraphQlQueryEngine");
/**
 * An {@link ActorRdfMetadataExtract} that extracts metadata based on a GraphQL-LD query.
 *
 * It exposes the {@link #queryData} method using which a query can be applied over the metadata stream.
 * For efficiency reasons, the query (and JSON-LD context) must be passed via the actor constructor
 * so that these can be pre-compiled.
 *
 * @see ActorRdfMetadataExtract
 */


var ActorRdfMetadataExtractQuery =
/*#__PURE__*/
function (_ActorRdfMetadataExtr) {
  _inherits(ActorRdfMetadataExtractQuery, _ActorRdfMetadataExtr);

  function ActorRdfMetadataExtractQuery(context, query, args) {
    var _this;

    _classCallCheck(this, ActorRdfMetadataExtractQuery);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActorRdfMetadataExtractQuery).call(this, args)); // Pre-parse GraphQL-LD query

    _this.graphqlClient = new graphql_ld_1.Client({
      context: context,
      queryEngine: new GraphQlQueryEngine_1.GraphQlQueryEngine(_this.queryEngine)
    });
    _this.sparqlOperation = _this.graphqlClient.graphQlToSparql({
      query: query
    });
    return _this;
  }
  /**
   * Execute the configured query on the given metadata stream.
   * @param {RDF.Stream} dataStream A quad stream to query on.
   * @return The GraphQL query results.
   */


  _createClass(ActorRdfMetadataExtractQuery, [{
    key: "queryData",
    value: function () {
      var _queryData = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dataStream, initialBindings) {
        var store, _ref, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return rdf_store_stream_1.storeStream(dataStream);

              case 2:
                store = _context.sent;
                _context.t0 = this.graphqlClient;
                _context.t1 = Object;
                _context.t2 = {};
                _context.next = 8;
                return this.sparqlOperation;

              case 8:
                _context.t3 = _context.sent;
                _context.t4 = {
                  queryEngineOptions: {
                    source: {
                      type: 'rdfjsSource',
                      value: store
                    },
                    initialBindings: initialBindings
                  }
                };
                _context.t5 = _context.t1.assign.call(_context.t1, _context.t2, _context.t3, _context.t4);
                _context.next = 13;
                return _context.t0.query.call(_context.t0, _context.t5);

              case 13:
                _ref = _context.sent;
                data = _ref.data;
                return _context.abrupt("return", data);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function queryData(_x, _x2) {
        return _queryData.apply(this, arguments);
      }

      return queryData;
    }()
  }]);

  return ActorRdfMetadataExtractQuery;
}(ActorRdfMetadataExtract_1.ActorRdfMetadataExtract);

exports.ActorRdfMetadataExtractQuery = ActorRdfMetadataExtractQuery;